import * as S from './Error.style';

export { default as Error } from './Error';
export * from './Error.types';
export { S };
